import BaseModelInformationTracking from "@/models/BaseModelInformationTracking.js";
export const GridConfig = {
	list: BaseModelInformationTracking.list,
	columns: BaseModelInformationTracking.columns,
	grid: {
		gridId: 'InformationTrackingGrid',
		height: 500,
		checkbox: true,
		edit: true,
		delete: false,
		pageSize: 100,
		groupable: true,
		document: true
	}
}
export const InfoTrackerToolbarConfig = {
	list: 'ToolBarItems',
	items: [
		// {
		// 	id: "btnCalculate",
		// 	type: "button",
		// 	text: "Calculate",
		// 	showIcon: "toolbar",
		// 	icon: "calculator",
		// 	attributes: {
		// 		"class": " btn btn-primary float-right-btn"
		// 	},
		// },
		{
			id: "btnAddInfoTracker",
			type: "button",
			text: "Add Information Tracker",
			showIcon: "toolbar",
			icon: "plus-circle",
			attributes: {
				"class": "btn btn-secondary float-right-btn"
			}
		},
		{
			id: "btnBulkImportIssuance",
			type: "button",
			text: "Bulk Import",
			showIcon: "toolbar",
			icon: "upload",
			attributes: {
				"class": "float-right-btn btn btn-tertiary"
			},
		},
	]

}
export const InfoTrackerUpdateConfig = {
	list: BaseModelInformationTracking.list,
	columns: {
		Id: {
			dataName: "Id",
			type: "number"
		},
		Status: {
			dataName: "Status",
			type: "string"
		}
	}
};